import { GridRenderCellParams } from "@mui/x-data-grid-premium";

import CopyableTypography, { CopyableTypographyProps } from "./CopyableTypography";

/**
 * A copyable value inside a grid cell: it takes the cell's roving `tabIndex`, so
 * rows don't each add a Tab stop, and is named after its column for screen readers.
 */
export function CopyableCellValue({
  params,
  ...props
}: { params: GridRenderCellParams } & Omit<CopyableTypographyProps, "tabIndex">) {
  return (
    <CopyableTypography
      tabIndex={params.tabIndex}
      copyLabel={params.colDef.headerName}
      {...props}
    />
  );
}
